import { cn } from "@/utils/utils";
import React from "react";

function YoutubeOutlineIcon({ className }: { className?: string }) {
  return (
    <span className={cn("block w-4 h-4 text-gray-200", className)}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 14 11"
        fill="none"
      >
        <path
          d="M11.0152 0.333984H2.98474C1.5227 0.333984 0.333313 1.52718 0.333313 2.99358V7.47004C0.333313 8.93671 1.5227 10.1296 2.98474 10.1296H11.0152C12.4773 10.1296 13.6666 8.93643 13.6666 7.47004V2.99358C13.6666 1.52718 12.4773 0.333984 11.0152 0.333984ZM13.1224 7.47031C13.1224 8.63684 12.1771 9.58569 11.0152 9.58569H2.98474C1.82284 9.58569 0.877531 8.63657 0.877531 7.47031V2.99358C0.877531 1.82732 1.82284 0.878202 2.98474 0.878202H11.0152C12.1771 0.878202 13.1224 1.82732 13.1224 2.99358V7.47031Z"
          fill="currentColor"
        />
        <path
          d="M9.41104 5.13405L5.64097 2.92589C5.55716 2.87691 5.45294 2.87609 5.36832 2.92453C5.28369 2.97296 5.23145 3.06303 5.23145 3.16072V7.57677C5.23145 7.67419 5.28369 7.76453 5.36804 7.81296C5.40995 7.83691 5.45675 7.84888 5.50355 7.84888C5.55117 7.84888 5.59852 7.83636 5.64097 7.8116L9.41104 5.60398C9.4943 5.55527 9.54573 5.46575 9.54573 5.36915C9.54573 5.27255 9.49458 5.18276 9.41104 5.13405ZM5.77566 7.10194V3.63527L8.73512 5.36888L5.77566 7.10194Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
}

export default YoutubeOutlineIcon;
